import Transfer from './src/transfer2.mjs';
export { LEFT_CHECK_CHANGE_EVENT, RIGHT_CHECK_CHANGE_EVENT, transferCheckedChangeFn, transferEmits, transferProps } from './src/transfer.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElTransfer = withInstall(Transfer);

export { ElTransfer, ElTransfer as default };
//# sourceMappingURL=index.mjs.map
